import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@roger/ui-components';
import { ExternalLink } from 'lucide-react';

const USER_GUIDE_URL = 'https://roger-health-user-guide.notion.site/';
const ADMIN_GUIDE_URL =
  'https://roger-health-user-guide.notion.site/Roger-Admin-Guide-344aebb6b840818aa352fef2dd161e54';

const Resources: React.FC = () => {
  return (
    <div className='space-y-6'>
      <div className='grid gap-6 max-w-2xl'>
        <Card>
          <CardHeader>
            <CardTitle>User Guide</CardTitle>
          </CardHeader>
          <CardContent className='space-y-2'>
            <p className='text-sm text-muted-foreground'>
              For a detailed walkthrough of Roger features and best practices,
              open the Roger User Guide.
            </p>
            <a
              href={USER_GUIDE_URL}
              target='_blank'
              rel='noreferrer'
              className='inline-flex items-center text-sm font-medium text-primary hover:underline'
            >
              Open User Guide
              <ExternalLink className='ml-1 h-4 w-4' />
            </a>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Admin Guide</CardTitle>
          </CardHeader>
          <CardContent className='space-y-2'>
            <p className='text-sm text-muted-foreground'>
              For agency setup, permissions, and administrative workflows, open
              the Roger Admin Guide.
            </p>
            <a
              href={ADMIN_GUIDE_URL}
              target='_blank'
              rel='noreferrer'
              className='inline-flex items-center text-sm font-medium text-primary hover:underline'
            >
              Open Admin Guide
              <ExternalLink className='ml-1 h-4 w-4' />
            </a>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Need help?</CardTitle>
          </CardHeader>
          <CardContent className='space-y-2'>
            <p className='text-sm text-muted-foreground'>
              If you have questions or need assistance, please contact our
              support team. We&apos;re here to help.
            </p>
            <p className='text-sm'>
              Email:{' '}
              <a
                href='mailto:support@rogerhealthcare.com'
                className='font-medium text-primary hover:underline'
              >
                support@rogerhealthcare.com
              </a>
            </p>
            <p className='text-xs text-muted-foreground'>
              We&apos;ll keep adding more resources here over time.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Resources;
